import React from 'react';
import { Box } from 'pounceV2';
import { ListChildComponentProps } from 'react-window';
import { useTheme } from '@mui/material';

const GroupRowV3 = (props: ListChildComponentProps) => {
  const {
    palette: { componentTokens, typographyTokens },
  } = useTheme();
  const { index, style, data } = props;
  const { items, renderItem } = data;
  const rowData = items[index];
  const [groupName, rowItems] = rowData;

  const inlineStyles = {
    ...style,
    listStyle: 'none',
  };

  return (
    <Box aria-label={`Group ${groupName}`} as="li" whiteSpace="nowrap" sx={inlineStyles}>
      {groupName && (
        <Box
          sx={{
            position: 'sticky',
            backgroundColor: componentTokens.selectMenuItems.color.item.background.containerBase,
            color: componentTokens.selectMenuItems.color.item.text.header.resting,
            top: 0,
            fontWeight: typographyTokens.fontWeights.bold,
            zIndex: 1,
            padding: 3,
          }}
        >
          {groupName}
        </Box>
      )}
      <Box as="ul" role="listbox">
        {rowItems.map(item => renderItem({ item, isNested: true }))}
      </Box>
    </Box>
  );
};

export default GroupRowV3;
